export default () => ({
  dialogTitle: {
    padding: 0
  },
  dialogContent: {
    padding: 0
  }
});
